import { CRMRequestService, getCancelableRequest } from './http.config';

const HistoryHttpService = {
    getHistoryList: () => {
        return getCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: ({ objectType, objectId }) => `/History/Get?objectType=${objectType}&objectId=${objectId}`,
        });
    },
};

export default HistoryHttpService;
